"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = require("axios");
class DMSRESTApiClient {
    //endregion
    //region Constructor
    constructor(scheme, dmsHost, dmsPort) {
        //endregion
        //region Private Methods
        this.getLoginHeaders = (jwtToken) => {
            return {
                "Authorization": "Bearer " + jwtToken
            };
        };
        //endregion
        //region Public Methods
        this.login = (username, password, twoFactorAuthSecret, twoFactorAuthToken) => __awaiter(this, void 0, void 0, function* () {
            const payload = { username, password, twoFactorAuthSecret, twoFactorAuthToken };
            let jwt = "";
            const response = yield axios_1.default.post(this.apiBaseUrl + "login", payload);
            if (response.status !== 200) {
                const error = Error(response.statusText);
                // @ts-ignore
                error["response"] = response;
                throw error;
            }
            jwt = response.data;
            return jwt;
        });
        this.invalidate = (jwtToken, tokenToInvalidate) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(this.apiBaseUrl + "invalidate", { tokenToInvalidate }, {
                headers: this.getLoginHeaders(jwtToken)
            });
            if (response.status === 200) {
                return response.data;
            }
            else {
                throw new Error(response.statusText);
            }
        });
        this.getMe = (jwtToken) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(this.apiBaseUrl + "me", {
                headers: this.getLoginHeaders(jwtToken)
            });
            if (response.status === 200) {
                return response.data;
            }
            else {
                throw new Error(response.statusText);
            }
        });
        this.changePassword = (jwtToken, username, currentPassword, newPassword) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(this.apiBaseUrl + "update_password", {
                username,
                currentPassword,
                newPassword
            }, {
                headers: this.getLoginHeaders(jwtToken)
            });
            if (response.status === 200) {
                return response.data;
            }
            else {
                throw new Error(response.statusText);
            }
        });
        this.getNodes = (jwtToken) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(this.apiBaseUrl + "nodes", {
                headers: this.getLoginHeaders(jwtToken)
            });
            if (response.status === 200) {
                return response.data;
            }
            else {
                throw new Error(response.statusText);
            }
        });
        this.getAppUsers = (jwtToken) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(this.apiBaseUrl + "app_users", {
                headers: this.getLoginHeaders(jwtToken)
            });
            if (response.status === 200) {
                return response.data;
            }
            else {
                throw new Error(response.statusText);
            }
        });
        this.deleteUser = (jwtToken, username) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(this.apiBaseUrl + "delete_user", { username }, {
                headers: this.getLoginHeaders(jwtToken)
            });
            if (response.status === 200) {
                return response.data;
            }
            else {
                throw new Error(response.statusText);
            }
        });
        this.registerUser = (jwtToken, username, password, isAppUser, memberOf) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(this.apiBaseUrl + "register_user", {
                username,
                password,
                isAppUser,
                memberOf
            }, {
                headers: this.getLoginHeaders(jwtToken)
            });
            if (response.status === 200 || response.status === 400) {
                return response.data;
            }
            else {
                throw new Error(response.statusText);
            }
        });
        this.registerNode = (jwtToken, nodeName, location) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(this.apiBaseUrl + "register_node", { nodeName, location }, {
                headers: this.getLoginHeaders(jwtToken)
            });
            if (response.status === 200) {
                return response.data;
            }
            else {
                throw new Error(response.statusText);
            }
        });
        this.deleteNode = (jwtToken, nodeName) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(this.apiBaseUrl + "delete_node", { nodeName }, {
                headers: this.getLoginHeaders(jwtToken)
            });
            if (response.status === 200) {
                return response.data;
            }
            else {
                throw new Error(response.statusText);
            }
        });
        this.uploadFileToBucket = (jwtToken, file, onUploadProgressChanged) => __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append("file", file);
            const response = yield axios_1.default.post(this.apiBaseUrl + "bucket_upload_file", formData, {
                headers: this.getLoginHeaders(jwtToken),
                onUploadProgress: progressEvent => {
                    const uploadProgress = progressEvent.loaded / progressEvent.total * 100;
                    onUploadProgressChanged(uploadProgress);
                }
            });
            return response.data;
        });
        this.listFilesFromBucket = (jwtToken) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(this.apiBaseUrl + "bucket_list_files", null, {
                headers: this.getLoginHeaders(jwtToken)
            });
            return response.data;
        });
        this.deleteFileFromBucket = (jwtToken, filename) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(this.apiBaseUrl + "bucket_delete_file", { filename }, {
                headers: this.getLoginHeaders(jwtToken)
            });
            return response.data;
        });
        this.getBitbucketConfig = (jwtToken, nodeName, nodeLocation, softwareName) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(this.apiBaseUrl + "get_bitbucket_config", {
                nodeName,
                nodeLocation,
                softwareName,
            }, {
                headers: this.getLoginHeaders(jwtToken)
            });
            return response.data;
        });
        this.getBitbucketConfigs = (jwtToken, nodeLocation, softwareName) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(this.apiBaseUrl + "get_bitbucket_configs", {
                nodeLocation,
                softwareName,
            }, {
                headers: this.getLoginHeaders(jwtToken)
            });
            return response.data;
        });
        this.getGlobalSettings = (jwtToken) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(this.apiBaseUrl + "global_settings", {
                headers: this.getLoginHeaders(jwtToken)
            });
            return response.data;
        });
        this.getActivityLog = (jwtToken) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.get(this.apiBaseUrl + "activity", {
                headers: this.getLoginHeaders(jwtToken)
            });
            return response.data;
        });
        this.postSlackUpdate = (jwtToken, msg) => __awaiter(this, void 0, void 0, function* () {
            const response = yield axios_1.default.post(this.apiBaseUrl + "post_slack_update", msg, {
                headers: this.getLoginHeaders(jwtToken)
            });
            if (response.status === 200) {
                return response.data;
            }
            else {
                throw new Error(response.statusText);
            }
        });
        this.apiBaseUrl = `${scheme}://${dmsHost}:${dmsPort}/api/`;
    }
}
exports.default = DMSRESTApiClient;
//# sourceMappingURL=DMSRESTApiClient.js.map